const w = window as Window;

// Fix "ReferenceError: __importDefault is not defined"
(w as any).__importDefault =
    (w && (w as any).__importDefault) ||
    function (mod: any) {
        return mod && mod.__esModule ? mod : { default: mod };
    };
